(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("7rUq7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f4941a9a7c262f$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");

var $2hYdk = parcelRequire("2hYdk");



































var $24f4941a9a7c262f$export$2e2bcd8739ae039 = async (tracker)=>{
    const { context: context } = tracker;
    // We are subscribing to the observable to get the eccomerce events
    (0, $2hYdk.default).subscribe(({ transactionEvent: transactionEvent, addToCartEvent: addToCartEvent, removeFromCartEvent: removeFromCartEvent })=>{
        transactionEvent && tracker.ecommerce.trackTransaction(transactionEvent);
        addToCartEvent && tracker.ecommerce.trackAddToCart(addToCartEvent);
        removeFromCartEvent && tracker.ecommerce.trackRemoveFromCart(removeFromCartEvent);
    });
    // We are dynamically loading the data source publisher/notifier based on the environment
    //* WARNING: Do not use absolute imports when dynamically loading modules
    switch(context.environment){
        case "bigcommerce":
            (parcelRequire("4XUfq")).then(({ default: load })=>load(tracker));
            break;
        case "blaze":
            (parcelRequire("efTgd")).then(({ default: load })=>load());
            break;
        case "buddi":
            (parcelRequire("dDMjE")).then(({ default: load })=>load());
            break;
        case "dispense":
            (parcelRequire("9N1hH")).then(({ default: load })=>load(tracker));
            break;
        case "drupal":
            (parcelRequire("l6cn1")).then(({ default: load })=>load());
            break;
        case "dutchie-iframe":
            (parcelRequire("gm5d1")).then(({ default: load })=>load());
            break;
        case "dutchie-subdomain":
            (parcelRequire("hc9sJ")).then(({ default: load })=>load());
            break;
        case "dutchieplus":
            (parcelRequire("aQZ9K")).then(({ default: load })=>load());
            break;
        case "dutchie":
            (parcelRequire("2RL0Q")).then(({ default: load })=>load());
            break;
        case "ecwid":
            (parcelRequire("jX4FL")).then(({ default: load })=>load());
            break;
        case "foxy":
            (parcelRequire("lIcBT")).then(({ default: load })=>load());
            break;
        case "grassdoor":
            (parcelRequire("amTkO")).then(({ default: load })=>load());
            break;
        case "greenrush":
            (parcelRequire("kVLCj")).then(({ default: load })=>load());
            break;
        case "iqmetrix":
            (parcelRequire("9cx4M")).then(({ default: load })=>load());
            break;
        case "jane":
            (parcelRequire("2Vf17")).then(({ default: load })=>load(tracker));
            break;
        case "leafly":
            (parcelRequire("2nM2z")).then(({ default: load })=>load());
            break;
        case "lightspeed":
            (parcelRequire("lcBTI")).then(({ default: load })=>load());
            break;
        case "magento":
            (parcelRequire("bm1s6")).then(({ default: load })=>load());
            break;
        case "meadow":
            (parcelRequire("90jdl")).then(({ default: load })=>load());
            break;
        case "olla":
            (parcelRequire("fJ5GE")).then(({ default: load })=>load());
            break;
        case "shopify":
            (parcelRequire("2wSNI")).then(({ default: load })=>load());
            break;
        case "square":
            (parcelRequire("liduW")).then(({ default: load })=>load());
            break;
        case "sticky-leaf":
            (parcelRequire("7zLDH")).then(({ default: load })=>load());
            break;
        case "sweed":
            (parcelRequire("dIVdb")).then(({ default: load })=>load());
            break;
        case "tymber":
            (parcelRequire("hf9bh")).then(({ default: load })=>load());
            break;
        case "ticketmaster":
            (parcelRequire("deKcO")).then(({ default: load })=>load());
            break;
        case "ticketure":
            (parcelRequire("jjeti")).then(({ default: load })=>load());
            break;
        case "tnew":
            (parcelRequire("eO0Co")).then(({ default: load })=>load());
            break;
        case "weave":
            (parcelRequire("3IiRU")).then(({ default: load })=>load());
            break;
        case "webjoint":
            (parcelRequire("djq0P")).then(({ default: load })=>load());
            break;
        case "wefunder":
            (parcelRequire("ZU7gR")).then(({ default: load })=>load());
            break;
        case "wix":
            (parcelRequire("l2ECz")).then(({ default: load })=>load());
            break;
        case "woocommerce":
            (parcelRequire("kv8M4")).then(({ default: load })=>load());
            break;
        case "yotpo":
            (parcelRequire("as6GW")).then(({ default: load })=>load());
            break;
        case "thirdparty":
            (parcelRequire("9kRGn")).then(({ default: load })=>load());
            break;
        default:
            (0, $lwczO.default).warn("No event/environment specified, Only pageview is active");
            break;
    }
};

});
parcelRegister("2hYdk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17e4af147803eaae$export$2e2bcd8739ae039; });
const $17e4af147803eaae$var$createObservable = ()=>{
    const listeners = [];
    return {
        listeners: listeners,
        subscribe: (fn)=>{
            listeners.push(fn);
        },
        unsubscribe: (fn)=>{
            const index = listeners.indexOf(fn);
            if (index > -1) listeners.splice(index, 1);
        },
        notify: (data)=>listeners.forEach((fn)=>fn(data))
    };
};
const $17e4af147803eaae$var$createEventsObservable = (()=>{
    let instance = null;
    return ()=>{
        if (!instance) instance = $17e4af147803eaae$var$createObservable();
        return instance;
    };
})();
const $17e4af147803eaae$var$observable = $17e4af147803eaae$var$createEventsObservable();
var $17e4af147803eaae$export$2e2bcd8739ae039 = $17e4af147803eaae$var$observable;

});

parcelRegister("4XUfq", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("6NtUh")).then(()=>parcelRequire("dPAKA"));

});

parcelRegister("efTgd", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("7kseD")).then(()=>parcelRequire("2pCXW"));

});

parcelRegister("dDMjE", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("k6WnI")).then(()=>parcelRequire("3NNNW"));

});

parcelRegister("9N1hH", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("5P0NC")).then(()=>parcelRequire("aPBGq"));

});

parcelRegister("l6cn1", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("bvWSZ")).then(()=>parcelRequire("7CjLf"));

});

parcelRegister("gm5d1", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("5QIpC")).then(()=>parcelRequire("45EB9"));

});

parcelRegister("hc9sJ", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("4Xfd5")).then(()=>parcelRequire("4IGTl"));

});

parcelRegister("aQZ9K", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("jgSon")).then(()=>parcelRequire("jPBao"));

});

parcelRegister("2RL0Q", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("jgSon")),
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("4Xfd5")),
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("5QIpC")),
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("jAQaW"))
]).then(()=>parcelRequire("gHuXK"));

});

parcelRegister("jX4FL", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("292sz")).then(()=>parcelRequire("7XV9p"));

});

parcelRegister("lIcBT", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("HtKqv")).then(()=>parcelRequire("01Tl8"));

});

parcelRegister("amTkO", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("9voW2")).then(()=>parcelRequire("1oyy4"));

});

parcelRegister("kVLCj", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("jFecf")).then(()=>parcelRequire("5ok7a"));

});

parcelRegister("9cx4M", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("hraRe")).then(()=>parcelRequire("aB3cV"));

});

parcelRegister("2Vf17", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("kp1Mc")).then(()=>parcelRequire("d4u6f"));

});

parcelRegister("2nM2z", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("3mysF")).then(()=>parcelRequire("d7OHU"));

});

parcelRegister("lcBTI", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("5thz2")).then(()=>parcelRequire("8djPr"));

});

parcelRegister("bm1s6", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("1lWLa")).then(()=>parcelRequire("1JSyC"));

});

parcelRegister("90jdl", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("5znd4")).then(()=>parcelRequire("iDpjN"));

});

parcelRegister("fJ5GE", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("4jzOF")).then(()=>parcelRequire("3ZPLq"));

});

parcelRegister("2wSNI", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("j9xDU")).then(()=>parcelRequire("1aFzU"));

});

parcelRegister("liduW", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("8FLYg")).then(()=>parcelRequire("j1Yqi"));

});

parcelRegister("7zLDH", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("4yUUm")).then(()=>parcelRequire("eyn6E"));

});

parcelRegister("dIVdb", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("jBZ8z")).then(()=>parcelRequire("cfehG"));

});

parcelRegister("hf9bh", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("8ITl5")).then(()=>parcelRequire("4axHD"));

});

parcelRegister("deKcO", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("cWZQT")).then(()=>parcelRequire("dptSB"));

});

parcelRegister("jjeti", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("cWZQT")),
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("kiJMr"))
]).then(()=>parcelRequire("ftvBx"));

});

parcelRegister("eO0Co", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("HtKqv")),
    (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("7tJCy"))
]).then(()=>parcelRequire("eyINy"));

});

parcelRegister("3IiRU", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("euBXr")).then(()=>parcelRequire("tCnJp"));

});

parcelRegister("djq0P", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("5620G")).then(()=>parcelRequire("zWg3W"));

});

parcelRegister("ZU7gR", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("dPOq8")).then(()=>parcelRequire("2YFbr"));

});

parcelRegister("l2ECz", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("lj3rq")).then(()=>parcelRequire("jVBUk"));

});

parcelRegister("kv8M4", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("fwDWh")).then(()=>parcelRequire("4LSXO"));

});

parcelRegister("as6GW", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("9xs8E")).then(()=>parcelRequire("6z0SB"));

});

parcelRegister("9kRGn", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("ltium")).then(()=>parcelRequire("5p3pM"));

});


})();
//# sourceMappingURL=ecommerce.b1792d05.js.map
